import {
    BoxIsolatedContent,
    FlexColumn,
    FlexColumnCentered,
    FormGoBack, TitlePhoneEmail,
} from "../../../components/ui/Content"
import {cleanError, resetPasswordFilled, resetState, SetPassword} from "../slice";
import {GoBack} from "../../../icon/Icon";
import {FormTitle } from "../../../components/Font"
import {RegisterInputContainer} from "../../../components/ui/InputSearch";
import {InputAutoCompleteEnum, InputElement, InputTypeEnum} from "../../../ui/Input/Input";
import {ButtonPrimary} from "../../../components/ui/Button";
import React, {useEffect, useState} from "react";
import {useAppDispatch, useAppSelector} from "../../../app/hooks";
import {useTranslation} from "react-i18next";
import {useTheme} from "styled-components";
import {useLocation, useNavigate} from "react-router-dom";
import {LoaderContainer, LoaderEnum, MiniLoader} from "../../../ui/Loader/MiniLoader";

interface IPasswordFormProps {
    onGoBack(): void
}

export const PasswordForm = ({onGoBack}: IPasswordFormProps) => {
    const {error, isFetching, passwordFilled} = useAppSelector(state => state.auth)
    const dispatch = useAppDispatch()
    const {t} = useTranslation()
    const navigate = useNavigate()
    const {search} = useLocation()
    const Theme = useTheme()
    const [form, setForm] = useState({
        password: '',
        password_repeat: '',
    })

    useEffect(() => {
        if (passwordFilled) {
            dispatch(resetState())
            dispatch(resetPasswordFilled())
            navigate(`/sign-in${search}`)
        }
    }, [passwordFilled])


    const disable = () => {
        return (form.password.length < 1) || isFetching
    }
    return <FlexColumnCentered
        className={'box-isolated'}>
        <BoxIsolatedContent>
            <FlexColumn style={{width: '100%'}}>
                <FlexColumnCentered>
                    <FormGoBack
                        onClick={onGoBack}>
                        <GoBack/>
                    </FormGoBack>
                    <FormTitle>{t('auth.registration')}</FormTitle>
                </FlexColumnCentered>
            </FlexColumn>

            <RegisterInputContainer>
                <InputElement
                    placeholder={t('auth.password')}
                    error={error['password']}
                    type={InputTypeEnum.Password}
                    value={form.password}
                    onChange={value => {
                        setForm({...form, password: value})
                        if (error['password']) {
                            dispatch(cleanError('password'))
                            dispatch(cleanError('password_repeat'))
                        }
                    }}
                    autoComplete={InputAutoCompleteEnum.NewPassword}
                />
            </RegisterInputContainer>
            <TitlePhoneEmail style={{ width: '100%', marginTop: '5px' }}>
                {t('passport.registrationForm.passwordForm.text')}
            </TitlePhoneEmail>

            <RegisterInputContainer>
                <InputElement
                    placeholder={t('auth.repeatPassword')}
                    type={InputTypeEnum.Password}
                    error={error['password_repeat']}
                    onKeyDown={key => {
                        if (key === 'Enter' && !disable()) {
                            dispatch(SetPassword(form))
                        }
                    }}
                    value={form.password_repeat}
                    onChange={value => {
                        setForm({...form, password_repeat: value})
                        if (error['password_repeat']) {
                            dispatch(cleanError('password'))
                            dispatch(cleanError('password_repeat'))
                        }
                    }}
                    autoComplete={InputAutoCompleteEnum.NewPassword}
                />
            </RegisterInputContainer>

            {isFetching
                ? <ButtonPrimary>
                    <LoaderContainer>
                        <MiniLoader color={Theme.color.primaryBackground} size={LoaderEnum.small}/>
                    </LoaderContainer>
                </ButtonPrimary>
                : <ButtonPrimary
                    disabled={disable()}
                    onClick={() => {
                        dispatch(SetPassword(form))
                    }}>
                    {t('auth.register')}
                </ButtonPrimary>}
        </BoxIsolatedContent>
    </FlexColumnCentered>
}
